import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Archery from '../../template/HomeworkNew/Archery';
import StepChange from '../../template/HomeworkNew/StepChange';
import ProgressBar from '../../template/HomeworkNew/ProgressBar';
import CloseIcon from '../../template/HomeworkNew/CloseIcon';
import { COURSE_URL, ROUND_NAME } from "../../constants";
import { parseQuery, myStorage } from '../../utils/tools';
import clientApi from '../../api/client';
import {apiDefine} from '../../api/web';
import AXIOS from '../../api/axios';

class ArcheryPage extends Component {
    constructor(props){
        super(props);
        this.storage = myStorage;
        this.queryObj = parseQuery(window.location.search.slice(1));
        this.questionList = [];
        this.state = {
            showStepChange: true,
            currentIndex:Number(props.match.params.index) - 1,
            totalIndex: NaN,
            level0: this.queryObj.castletype === '3' || this.queryObj.castletype === 3,
            device: JSON.parse(this.storage.getItem('panda_client_data')).device
        };
        this.timeOutArr = [];
    }
    componentDidMount(){
        const { currentIndex } = this.state;
        apiDefine({apiName:'alertViewBack',fn:this.alertViewBack}); // 定义弹框回调方法
        let curRoundIndex, _questionList;
        try {
            _questionList = JSON.parse(this.storage.getItem('panda_homework_questioninfo'));
            this.sort = JSON.parse(this.storage.getItem('panda_homework_sort'));
        } catch (error) {
            clientApi.alertView({
                content: '作业异常，请重新开始',
                confirm: '确认',
                id:'H5_1005'
            });
            console.log(error)
        }
        curRoundIndex = this.sort.indexOf(2);
        this.questionList = _questionList[curRoundIndex];
        this.storage.setItem('panda_homework_next',curRoundIndex + 1);
        this.setState({
            completeRender: true,
            questionInfo:this.questionList[currentIndex],
            totalIndex: this.questionList.length - 1
        });
        this.timeOutArr.push(
            setTimeout(() => {
                this.stepChangeRef.cloudPlay(()=>{
                    this.timeOutArr.push(
                        setTimeout(() => {
                            this.setState({
                                showStepChange: false,
                                stepChange: 'out'
                            })
                        }, 1200)
                    );
                })
            }, 400)
        )
    }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }
    alertViewBack = () => {
        clientApi.closeH5Page({reason: 'homeworkError'})
    }
    nextQuestion = (score) => {
        const { currentIndex, totalIndex, device } = this.state;
        const { classschid } = this.queryObj;
        if(currentIndex + 1 > totalIndex){
            this.setState({
                showStepChange: true
            }, () => {this.stepChangeRef.cloudPlay()});
            const nextIndex = this.storage.getItem('panda_homework_next');
            const nextRound = ROUND_NAME[this.sort[Number(nextIndex)]];
            const nextPath = nextRound? `${nextRound}/1` : `result`;
            const { history } = this.props;
            setTimeout(() => {
                history.push({
                    pathname: `${COURSE_URL}/homework/${nextPath}`,
                    search: window.location.search,
                })
            },1000)
        }
        else{
            const { history } = this.props;
            history.push({
                pathname: `${COURSE_URL}/homework/archery/${currentIndex + 2}`,
                search: `${window.location.search}`,
            });
            this.child.child.setStep('step1');
            this.child.restart();
            this.setState({
                currentIndex: currentIndex + 1,
                questionInfo: this.questionList[currentIndex + 1]
            })
        }
        const params = {
            type: 0,
            device: device,
            classSchId: classschid,
            index: Number('2' + (currentIndex + 1)),
            isRight: score > 30 ? 1 : 0
        }
        const paramsBp = {
            courseId: 210, // 210-NGK
            sourceType: 2, // 1-课件 2-作业
            qaType: 3, //  题目类型 1-选择题、2-判断题、3-读音题、4-多选题
            qaTemplate: '射箭读单词', // 题目模板
            deviceName: device, // 设备
            classSchId: classschid, // 课次id
            qaResult: score // 分数
        }
        AXIOS.homeworkSave({data: params}, (res, err) => {
            if(err) console.log(err);
            else {
                console.log('作业保存进度成功');
            }
        });
        AXIOS.homeworkBp({ data: paramsBp }, (res, err) => {
            if(err) console.log(err);
            else {
                console.log('作业结果埋点成功');
            }
        });
    }

    render(){
        const { 
            level0,
            stepChange, 
            showStepChange, 
            currentIndex, 
            totalIndex, 
            questionInfo, 
            completeRender 
        } = this.state;
        return(
            <DocumentTitle title={'课后作业'}>
                <React.Fragment>
                    {completeRender &&
                        <div>
                            <CloseIcon closeReason="homeworkBreak" />
                            <ProgressBar currentNum={currentIndex + 1} totalNum={totalIndex + 1} insertColor={'#f55151'} outColor={'#adadad'} />
                            <Archery 
                                level0={level0}
                                questionInfo={questionInfo}
                                nextQuestion={this.nextQuestion} 
                                currentIndex={currentIndex} 
                                totalIndex={totalIndex} 
                                ref={com => this.child = com} 
                            />
                        </div>
                    }
                    {!!showStepChange && 
                        <StepChange status={stepChange || 'in'} ref={com => this.stepChangeRef = com} />
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default ArcheryPage;



// WEBPACK FOOTER //
// ./src/components/homeworkNewPage/ArcheryPage.jsx